var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMappaewayfinding = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    viewBox: "0 0 548.19 771.81",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n      stroke: #e2e2e2;\n      stroke-miterlimit: 10;\n      stroke-width: 2.5px;\n      }\n\n      .cls-1, .cls-6 {\n      fill: #e2e2e2;\n      }\n\n      .cls-8 {\n      opacity: .5;\n      }\n\n      .cls-8, .cls-9 {\n      isolation: isolate;\n      }\n\n      .cls-8, .cls-3, .cls-10 {\n      fill: #093f75;\n      }\n\n      #Voi_siete_qui * {\n      fill : #d33d3d\n      }\n\n      .cls-2, .cls-11 {\n      fill: #144072;\n      }\n\n      .cls-4, .cls-5, .cls-12 {\n      fill: none;\n      }\n\n      .cls-4, .cls-12 {\n      stroke-linecap: round;\n      }\n\n      .cls-13, .cls-7 {\n      fill: #fff;\n      }\n\n      .cls-6 {\n      fill-rule: evenodd;\n      }\n\n      .cls-12 {\n      stroke: #093f75;\n      stroke-linejoin: round;\n      stroke-width: 5px;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "mappa"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.39,74.59h110.01v84.58h-107.44c-1.41,0-2.56-1.15-2.56-2.56v-82.02h0Z",
    transform: "translate(295.28 -61.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-15.04,41.98h94.43v61.3H-12.48c-1.41,0-2.56-1.15-2.56-2.56v-58.73h0Z",
    transform: "translate(104.8 40.46) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 11.74,
    y: 109.63,
    width: 40.86,
    height: 61.3,
    transform: "translate(172.45 108.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 151.37,
    width: 42.63,
    height: 61.3,
    transform: "translate(214.19 149.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 194.01,
    width: 42.63,
    height: 61.3,
    transform: "translate(256.83 192.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 236.64,
    width: 42.63,
    height: 61.3,
    transform: "translate(299.46 235.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 11.74,
    y: 492.7,
    width: 40.86,
    height: 61.3,
    transform: "translate(555.52 491.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 534.44,
    width: 42.63,
    height: 61.3,
    transform: "translate(597.27 532.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.9,631.76v-103.6c0-2.76,2.24-5,5-5h7.5c2.76,0,5-2.24,5-5v-248.23c0-2.76-2.24-5-5-5h-7.5c-2.76,0-5-2.24-5-5v-6.45c0-2.76,2.24-5,5-5h48.53v383.27h-53.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 577.08,
    width: 42.63,
    height: 61.3,
    transform: "translate(639.9 575.55) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 619.71,
    width: 42.63,
    height: 61.3,
    transform: "translate(682.53 618.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.86,
    y: 662.35,
    width: 42.63,
    height: 61.3,
    transform: "translate(725.17 660.82) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.76,709.07h48.26c1.41,0,2.56,1.15,2.56,2.56v56.17c0,1.41-1.15,2.56-2.56,2.56H6.76v-61.3h0Z",
    transform: "translate(771.89 707.55) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M7.43,285.15h82.67v92.14H4.87v-89.58c0-1.41,1.15-2.56,2.56-2.56Z",
    transform: "translate(378.71 283.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-16.96,392.4h126.33c1.41,0,2.56,1.15,2.56,2.56v89.58H-16.96v-92.14h0Z",
    transform: "translate(485.96 390.98) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.78,645.77h142.55c1.41,0,2.56,1.15,2.56,2.56v87.02c0,1.41-1.15,2.56-2.56,2.56H105.22v-89.58c0-1.41,1.15-2.56,2.56-2.56Z",
    transform: "translate(870.9 512.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 269.29,
    y: 12.85,
    width: 110.01,
    height: 208.06,
    transform: "translate(441.17 -207.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 425.5,
    y: 133.75,
    width: 177.29,
    height: 63.2,
    rx: 2.56,
    ry: 2.56,
    transform: "translate(679.5 -348.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 425.5,
    y: 550.47,
    width: 177.29,
    height: 63.2,
    rx: 2.56,
    ry: 2.56,
    transform: "translate(1096.22 67.93) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 93.06,
    y: 632.64,
    width: 40.68,
    height: 38.93,
    transform: "translate(765.51 538.7) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 132.98,
    y1: 652.1,
    x2: 93.9,
    y2: 652.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 128.82,
    y1: 672.44,
    x2: 128.82,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 124.47,
    y1: 672.44,
    x2: 124.47,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 120.12,
    y1: 672.44,
    x2: 120.12,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 115.77,
    y1: 672.44,
    x2: 115.77,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.43,
    y1: 672.44,
    x2: 111.43,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 107.08,
    y1: 672.44,
    x2: 107.08,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 102.73,
    y1: 672.44,
    x2: 102.73,
    y2: 631.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 98.39,
    y1: 672.44,
    x2: 98.39,
    y2: 631.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 494,
    y: 254.13,
    width: 40.68,
    height: 41.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 514.34,
    y1: 254,
    x2: 514.34,
    y2: 296.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 258.49,
    x2: 494,
    y2: 258.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 263.17,
    x2: 494,
    y2: 263.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 267.86,
    x2: 494,
    y2: 267.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 272.54,
    x2: 494,
    y2: 272.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 277.23,
    x2: 494,
    y2: 277.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 281.91,
    x2: 494,
    y2: 281.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 286.6,
    x2: 494,
    y2: 286.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 291.28,
    x2: 494,
    y2: 291.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 494,
    y: 450.63,
    width: 40.68,
    height: 41.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 514.34,
    y1: 450.5,
    x2: 514.34,
    y2: 492.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 454.99,
    x2: 494,
    y2: 454.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 459.68,
    x2: 494,
    y2: 459.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 464.36,
    x2: 494,
    y2: 464.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 469.04,
    x2: 494,
    y2: 469.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 473.73,
    x2: 494,
    y2: 473.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 478.41,
    x2: 494,
    y2: 478.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 483.1,
    x2: 494,
    y2: 483.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 534.69,
    y1: 487.78,
    x2: 494,
    y2: 487.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 93.01,
    y: 118.07,
    width: 40.68,
    height: 44.91,
    transform: "translate(253.87 27.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 135.93,
    y1: 140.53,
    x2: 90.85,
    y2: 140.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 131.13,
    y1: 160.87,
    x2: 131.13,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 126.11,
    y1: 160.87,
    x2: 126.11,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 121.1,
    y1: 160.87,
    x2: 121.1,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 116.08,
    y1: 160.87,
    x2: 116.08,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.07,
    y1: 160.87,
    x2: 111.07,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 106.05,
    y1: 160.87,
    x2: 106.05,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 101.04,
    y1: 160.87,
    x2: 101.04,
    y2: 120.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 96.02,
    y1: 160.87,
    x2: 96.02,
    y2: 120.18
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.43,
    y1: 586.41,
    x2: 147.43,
    y2: 617.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.43,
    y1: 172.05,
    x2: 147.43,
    y2: 248.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.83,765.56v-441.89c0-2.76-2.24-5-5-5h-4.58c-2.76,0-5-2.24-5-5V67.05c0-2.76-2.24-5-5-5h-21.36l.51,110.01h-9.75v593.34c0,2.76,2.24,5,5,5h20.51v.17h19.66c2.76,0,5-2.24,5-5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2126"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90",
    className: "cls-11",
    cx: 179.06,
    cy: 691.84,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "A",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M178.32,687.12h1.5l3.32,8.74h-1.75l-.81-2.18h-3.05l-.8,2.18h-1.75l3.33-8.74ZM180.27,692.49l-1.21-3.43-1.25,3.43h2.46Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2127"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-2",
    className: "cls-11",
    cx: 32.17,
    cy: 740.47,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "B",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M35.94,742.23c0,.37-.07.69-.22.97-.15.28-.35.51-.61.7s-.56.33-.9.43c-.34.1-.7.15-1.09.15h-4.22v-8.74h4.68c.3,0,.58.07.82.2.25.13.46.3.63.51.17.21.31.45.4.71.09.27.14.54.14.81,0,.43-.11.83-.32,1.2-.21.37-.53.65-.94.83.5.15.9.41,1.19.79.29.38.44.86.44,1.43ZM30.6,737.2v2.2h2.26c.29,0,.53-.1.73-.29.2-.2.3-.47.3-.81s-.09-.6-.28-.8c-.18-.2-.41-.29-.68-.29h-2.34ZM34.23,741.91c0-.16-.03-.31-.08-.45s-.12-.27-.21-.38c-.09-.11-.2-.19-.32-.25s-.26-.09-.41-.09h-2.61v2.3h2.52c.16,0,.3-.03.44-.09.14-.06.25-.14.35-.24.1-.1.18-.22.23-.36.06-.14.09-.29.09-.44Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2128"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-3",
    className: "cls-11",
    cx: 32.17,
    cy: 693.01,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "C",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M28.33,692.59c0-.53.1-1.06.29-1.58.19-.52.47-.99.84-1.4s.82-.74,1.35-1c.53-.25,1.14-.38,1.82-.38.8,0,1.5.18,2.08.53.59.35,1.02.81,1.31,1.38l-1.3.9c-.11-.25-.25-.45-.42-.62s-.34-.3-.53-.4-.39-.17-.59-.22c-.21-.04-.41-.07-.6-.07-.43,0-.8.09-1.11.26-.32.17-.58.4-.79.67-.21.28-.37.59-.47.94s-.16.7-.16,1.04c0,.39.06.76.18,1.11.12.36.3.67.52.94.23.27.5.49.81.65.32.17.66.25,1.04.25.2,0,.4-.02.62-.07.21-.05.42-.13.61-.23.19-.11.37-.24.54-.41.16-.17.29-.37.39-.61l1.39.8c-.14.33-.34.62-.6.87s-.55.46-.87.63c-.32.17-.67.3-1.04.39s-.73.14-1.08.14c-.62,0-1.19-.13-1.71-.39-.52-.26-.96-.6-1.34-1.03-.37-.42-.66-.9-.87-1.44s-.31-1.08-.31-1.64Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2129"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-4",
    className: "cls-11",
    cx: 32.17,
    cy: 650.82,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "D",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M28.68,654.83v-8.74h3.17c.71,0,1.34.12,1.88.34.54.23.99.54,1.35.94.36.39.63.85.81,1.38s.27,1.09.27,1.69c0,.67-.1,1.27-.3,1.8-.2.54-.49,1-.87,1.38-.38.38-.83.68-1.36.89s-1.12.31-1.78.31h-3.17ZM34.45,650.45c0-.42-.06-.8-.17-1.16-.11-.35-.28-.66-.5-.91-.22-.25-.49-.45-.82-.59s-.69-.21-1.1-.21h-1.48v5.76h1.48c.42,0,.79-.07,1.11-.22.32-.15.59-.35.81-.61.22-.26.38-.56.5-.92.12-.35.17-.73.17-1.14Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2130"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-5",
    className: "cls-11",
    cx: 32.17,
    cy: 566.45,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "F",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M29.55,570.46v-8.74h5.87v1.49h-4.17v2.25h3.47v1.38h-3.47v3.62h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2131"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-6",
    className: "cls-11",
    cx: 32.17,
    cy: 608.63,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "E",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M35.45,611.16v1.49h-6.07v-8.74h5.96v1.49h-4.26v2.1h3.68v1.38h-3.68v2.28h4.37Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2132"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-7",
    className: "cls-11",
    cx: 47.22,
    cy: 438.47,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "G",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M49.74,441.5c-.7.7-1.51,1.05-2.44,1.05-.57,0-1.11-.12-1.62-.34s-.94-.54-1.32-.95c-.37-.4-.67-.88-.89-1.42-.22-.55-.33-1.13-.33-1.77,0-.6.11-1.16.33-1.69s.52-.99.9-1.39c.38-.4.83-.71,1.35-.95.52-.23,1.08-.35,1.69-.35.82,0,1.52.17,2.11.52.59.34,1.03.81,1.32,1.39l-1.27.94c-.22-.43-.53-.77-.93-1s-.83-.34-1.3-.34c-.37,0-.71.08-1.02.23-.31.16-.57.37-.79.64-.22.27-.39.58-.5.93-.12.35-.18.73-.18,1.12s.07.79.2,1.15c.13.36.31.67.54.93.23.26.5.47.82.62.32.15.66.23,1.03.23.84,0,1.61-.4,2.29-1.19v-.62h-1.76v-1.24h3.16v4.49h-1.4v-.98Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2133"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-8",
    className: "cls-11",
    cx: 47.22,
    cy: 331.22,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.89,326.5v8.74h-1.69v-3.73h-3.96v3.73h-1.7v-8.74h1.7v3.53h3.96v-3.53h1.69Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2134"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-9",
    className: "cls-11",
    cx: 32.17,
    cy: 267.29,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "I",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.32,271.31v-8.74h1.7v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2135"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-10",
    className: "cls-11",
    cx: 32.17,
    cy: 524.26,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "K",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M28.96,528.27v-8.72h1.7v4.15l3.67-4.16h1.87l-3.35,3.88,3.56,4.86h-1.91l-2.72-3.78-1.12,1.17v2.61h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12",
    className: "cls-11",
    cx: 32.17,
    cy: 226.31,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M29.49,230.33v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13",
    className: "cls-11",
    cx: 32.17,
    cy: 182.02,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M34.88,186.04v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2139"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-14",
    className: "cls-11",
    cx: 32.17,
    cy: 140.28,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "N",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M30.09,138.69v5.6h-1.7v-8.74h1.32l4.55,5.73v-5.72h1.7v8.72h-1.38l-4.49-5.6Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2140"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-15",
    className: "cls-11",
    cx: 32.17,
    cy: 71.63,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "P",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M29.25,75.65v-8.74h3.7c.4,0,.77.08,1.11.25.34.17.63.39.88.67s.44.59.58.93c.14.35.21.7.21,1.05s-.07.73-.2,1.08c-.13.35-.32.66-.55.93-.24.27-.53.49-.86.65-.34.16-.71.25-1.11.25h-2.07v2.93h-1.7ZM30.95,71.23h1.97c.31,0,.57-.13.78-.38.21-.25.31-.6.31-1.03,0-.22-.03-.42-.1-.6-.07-.18-.15-.33-.26-.45s-.23-.22-.38-.28c-.14-.06-.29-.09-.44-.09h-1.9v2.83Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2141"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-16",
    className: "cls-11",
    cx: 178.39,
    cy: 116.88,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Q",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M180.6,120.33c-.32.2-.66.35-1.03.46s-.76.17-1.18.17c-.64,0-1.22-.13-1.74-.38-.52-.25-.97-.59-1.34-1-.37-.41-.66-.88-.87-1.42s-.31-1.08-.31-1.64.11-1.14.33-1.67.52-1,.9-1.42c.38-.41.83-.74,1.36-.98s1.1-.36,1.71-.36,1.21.13,1.73.39.97.6,1.34,1.02c.37.42.66.89.86,1.43.2.53.31,1.08.31,1.62s-.1,1.11-.3,1.62c-.2.52-.48.98-.84,1.38l1.19,1.34h-1.6l-.5-.57ZM178.4,119.46c.22,0,.43-.03.62-.08s.37-.12.54-.22l-1.33-1.5h1.6l.6.68c.16-.26.29-.55.38-.86.09-.31.14-.63.14-.95,0-.38-.06-.74-.18-1.09-.12-.35-.29-.67-.5-.94s-.48-.49-.8-.65-.67-.25-1.06-.25-.77.08-1.09.25c-.32.17-.59.39-.8.67-.21.28-.38.59-.49.94-.11.35-.17.7-.17,1.06s.06.74.17,1.09c.11.35.28.67.5.94.22.27.48.49.8.65.32.16.67.25,1.08.25Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1155",
    className: "cls-11",
    x: 289.14,
    y: 101.06,
    width: 70.31,
    height: 31.64,
    rx: 8.79,
    ry: 8.79
  }), /*#__PURE__*/React.createElement("g", {
    id: "SALA_PININFARINA",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M317.55,110.52s-.12-.1-.22-.17-.24-.14-.4-.21-.32-.12-.51-.17-.37-.07-.55-.07c-.33,0-.58.06-.75.18s-.25.3-.25.52c0,.13.03.24.09.32s.15.16.27.22.27.12.44.18.39.11.62.17c.3.08.58.17.83.26s.46.21.63.35.31.31.4.51.14.44.14.72c0,.33-.06.62-.19.86s-.3.43-.51.58-.46.25-.74.32c-.28.07-.57.1-.87.1-.47,0-.93-.07-1.39-.21s-.87-.34-1.23-.6l.54-1.05c.05.05.15.12.29.21s.3.17.49.25.4.16.62.21.46.09.7.09c.67,0,1-.21,1-.64,0-.13-.04-.25-.11-.34s-.18-.18-.33-.25-.31-.13-.51-.19-.42-.12-.67-.19c-.3-.08-.56-.17-.78-.27s-.4-.21-.55-.34-.26-.28-.33-.46-.11-.38-.11-.62c0-.32.06-.6.18-.84s.28-.45.49-.62.45-.29.73-.37.57-.13.89-.13c.44,0,.84.07,1.21.21s.69.3.97.49l-.54.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M320.89,108.88h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM322.28,112.71l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M325.02,115.12v-6.24h1.21v5.18h3.18v1.06h-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M331.93,108.88h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM333.32,112.71l-.86-2.45-.9,2.45h1.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M297.37,124.79v-6.24h2.65c.29,0,.55.06.8.18s.45.28.63.47.31.42.41.67.15.5.15.75-.05.52-.14.77-.23.47-.4.66-.38.35-.62.47-.5.18-.79.18h-1.48v2.09h-1.21ZM298.58,121.64h1.41c.22,0,.41-.09.56-.27s.22-.43.22-.74c0-.16-.02-.3-.07-.43s-.11-.23-.18-.32-.17-.15-.27-.2-.21-.07-.31-.07h-1.35v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M302.84,124.79v-6.24h1.21v6.24h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M306.57,120.79v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M312.06,124.79v-6.24h1.21v6.24h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M315.79,120.79v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M321.28,124.79v-6.24h4.19v1.06h-2.98v1.61h2.48v.98h-2.48v2.58h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M327.41,118.55h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM328.81,122.38l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M331.55,124.79v-6.24h2.76c.29,0,.55.06.8.18s.45.28.63.47.31.42.41.67.15.5.15.75c0,.4-.1.77-.3,1.1s-.48.57-.82.72l1.42,2.35h-1.36l-1.27-2.09h-1.2v2.09h-1.21ZM332.76,121.64h1.52c.11,0,.22-.03.31-.08s.18-.12.25-.21.13-.2.17-.32.06-.25.06-.4-.02-.28-.07-.4-.11-.23-.19-.32-.17-.16-.27-.21-.21-.08-.31-.08h-1.47v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M337.39,124.79v-6.24h1.21v6.24h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M341.12,120.79v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M348.38,118.55h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM349.78,122.38l-.86-2.45-.9,2.45h1.76Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1155-2",
    className: "cls-11",
    x: 497.35,
    width: 33.4,
    height: 21.97,
    rx: 8.79,
    ry: 8.79
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bar",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M510.93,12.45c0,.26-.05.5-.16.69s-.25.37-.44.5-.4.24-.64.31-.5.11-.78.11h-3.01v-6.24h3.34c.22,0,.41.05.59.14s.33.22.45.37.22.32.29.51.1.38.1.58c0,.3-.08.59-.23.86s-.38.46-.67.59c.36.11.64.29.85.57s.31.61.31,1.02ZM507.11,8.86v1.57h1.62c.21,0,.38-.07.52-.21s.22-.33.22-.58-.07-.43-.2-.57-.29-.21-.49-.21h-1.67ZM509.7,12.23c0-.11-.02-.22-.06-.32s-.09-.19-.15-.27-.14-.14-.23-.18-.18-.07-.29-.07h-1.86v1.64h1.8c.11,0,.22-.02.31-.06s.18-.1.25-.17.13-.16.17-.26.06-.21.06-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M513.52,7.82h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM514.92,11.66l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M517.65,14.06v-6.24h2.76c.29,0,.55.06.8.18s.45.28.63.47.31.42.41.67.15.5.15.75c0,.4-.1.77-.3,1.1s-.48.57-.82.72l1.42,2.35h-1.36l-1.27-2.09h-1.2v2.09h-1.21ZM518.86,10.91h1.52c.11,0,.22-.03.31-.08s.18-.12.25-.21.13-.2.17-.32.06-.25.06-.4-.02-.28-.07-.4-.11-.23-.19-.32-.17-.16-.27-.21-.21-.08-.31-.08h-1.47v2.02Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1155-3",
    className: "cls-11",
    x: 483.15,
    y: 362.16,
    width: 65.04,
    height: 31.64,
    rx: 8.79,
    ry: 8.79
  }), /*#__PURE__*/React.createElement("g", {
    id: "Scale_Ascensori",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M506.21,371.62s-.12-.1-.22-.17-.24-.14-.4-.21-.32-.12-.51-.17-.37-.07-.55-.07c-.33,0-.58.06-.75.18s-.25.3-.25.52c0,.13.03.24.09.32s.15.16.27.22.27.12.44.18.39.11.62.17c.3.08.58.17.83.26s.46.21.63.35.31.31.4.51.14.44.14.72c0,.33-.06.62-.19.86s-.3.43-.51.58-.46.25-.74.32c-.28.07-.57.1-.87.1-.47,0-.93-.07-1.39-.21s-.87-.34-1.23-.6l.54-1.05c.05.05.15.12.29.21s.3.17.49.25.4.16.62.21.46.09.7.09c.67,0,1-.21,1-.64,0-.13-.04-.25-.11-.34s-.18-.18-.33-.25-.31-.13-.51-.19-.42-.12-.67-.19c-.3-.08-.56-.17-.78-.27s-.4-.21-.55-.34-.26-.28-.33-.46-.11-.38-.11-.62c0-.32.06-.6.18-.84s.28-.45.49-.62.45-.29.73-.37.57-.13.89-.13c.44,0,.84.07,1.21.21s.69.3.97.49l-.54.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M507.51,373.06c0-.38.07-.76.21-1.13s.34-.71.6-1,.59-.53.97-.71.81-.27,1.3-.27c.57,0,1.07.13,1.49.38s.73.58.94.98l-.93.64c-.08-.18-.18-.32-.3-.44s-.24-.22-.38-.29-.28-.12-.42-.15-.29-.05-.43-.05c-.3,0-.57.06-.8.18s-.41.28-.56.48-.26.42-.34.67-.11.5-.11.74c0,.28.04.54.13.8s.21.48.37.67.35.35.58.47.47.18.74.18c.14,0,.29-.02.44-.05s.3-.09.44-.17.27-.17.38-.29.21-.27.28-.44l.99.57c-.1.23-.24.44-.43.62s-.39.33-.62.45-.48.22-.74.28-.52.1-.77.1c-.45,0-.85-.09-1.22-.28s-.69-.43-.95-.73-.47-.64-.62-1.03-.22-.78-.22-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M515.6,369.99h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM517,373.82l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M519.73,376.23v-6.24h1.21v5.18h3.18v1.06h-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M529.2,375.16v1.06h-4.33v-6.24h4.25v1.06h-3.04v1.5h2.63v.98h-2.63v1.63h3.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M493.29,379.65h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM494.69,383.49l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M501.05,381.29s-.12-.1-.22-.17-.24-.14-.4-.21-.32-.12-.51-.17-.37-.07-.55-.07c-.33,0-.58.06-.75.18s-.25.3-.25.52c0,.13.03.24.09.32s.15.16.27.22.27.12.44.18.39.11.62.17c.3.08.58.17.83.26s.46.21.63.35.31.31.4.51.14.44.14.72c0,.33-.06.62-.19.86s-.3.43-.51.58-.46.25-.74.32c-.28.07-.57.1-.87.1-.47,0-.93-.07-1.39-.21s-.87-.34-1.23-.6l.54-1.05c.05.05.15.12.29.21s.3.17.49.25.4.16.62.21.46.09.7.09c.67,0,1-.21,1-.64,0-.13-.04-.25-.11-.34s-.18-.18-.33-.25-.31-.13-.51-.19-.42-.12-.67-.19c-.3-.08-.56-.17-.78-.27s-.4-.21-.55-.34-.26-.28-.33-.46-.11-.38-.11-.62c0-.32.06-.6.18-.84s.28-.45.49-.62.45-.29.73-.37.57-.13.89-.13c.44,0,.84.07,1.21.21s.69.3.97.49l-.54.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M502.34,382.73c0-.38.07-.76.21-1.13s.34-.71.6-1,.59-.53.97-.71.81-.27,1.3-.27c.57,0,1.07.13,1.49.38s.73.58.94.98l-.93.64c-.08-.18-.18-.32-.3-.44s-.24-.22-.38-.29-.28-.12-.42-.15-.29-.05-.43-.05c-.3,0-.57.06-.8.18s-.41.28-.56.48-.26.42-.34.67-.11.5-.11.74c0,.28.04.54.13.8s.21.48.37.67.35.35.58.47.47.18.74.18c.14,0,.29-.02.44-.05s.3-.09.44-.17.27-.17.38-.29.21-.27.28-.44l.99.57c-.1.23-.24.44-.43.62s-.39.33-.62.45-.48.22-.74.28-.52.1-.77.1c-.45,0-.85-.09-1.22-.28s-.69-.43-.95-.73-.47-.64-.62-1.03-.22-.78-.22-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M513.08,384.83v1.06h-4.33v-6.24h4.25v1.06h-3.04v1.5h2.63v.98h-2.63v1.63h3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M515.24,381.89v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M524.45,381.29s-.12-.1-.22-.17-.24-.14-.4-.21-.32-.12-.51-.17-.37-.07-.55-.07c-.33,0-.58.06-.75.18s-.25.3-.25.52c0,.13.03.24.09.32s.15.16.27.22.27.12.44.18.39.11.62.17c.3.08.58.17.83.26s.46.21.63.35.31.31.4.51.14.44.14.72c0,.33-.06.62-.19.86s-.3.43-.51.58-.46.25-.74.32c-.28.07-.57.1-.87.1-.47,0-.93-.07-1.39-.21s-.87-.34-1.23-.6l.54-1.05c.05.05.15.12.29.21s.3.17.49.25.4.16.62.21.46.09.7.09c.67,0,1-.21,1-.64,0-.13-.04-.25-.11-.34s-.18-.18-.33-.25-.31-.13-.51-.19-.42-.12-.67-.19c-.3-.08-.56-.17-.78-.27s-.4-.21-.55-.34-.26-.28-.33-.46-.11-.38-.11-.62c0-.32.06-.6.18-.84s.28-.45.49-.62.45-.29.73-.37.57-.13.89-.13c.44,0,.84.07,1.21.21s.69.3.97.49l-.54.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M528.78,385.94c-.46,0-.87-.09-1.24-.27s-.69-.42-.96-.71-.47-.63-.62-1.02-.22-.77-.22-1.17.08-.81.23-1.2.37-.72.64-1.01.6-.53.97-.7.78-.26,1.22-.26.86.09,1.23.28.69.43.95.72.47.64.62,1.02.22.77.22,1.16c0,.42-.08.81-.23,1.19s-.36.71-.63,1-.59.52-.97.69-.78.26-1.22.26ZM526.97,382.77c0,.27.04.53.12.78s.2.47.36.67.35.35.57.47.48.18.77.18.55-.06.78-.18.42-.28.57-.48.27-.42.35-.67.12-.5.12-.76-.04-.53-.13-.78-.21-.47-.36-.67-.35-.35-.57-.46-.48-.17-.76-.17-.55.06-.78.18-.42.28-.57.47-.27.42-.35.67-.12.5-.12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M532.77,385.89v-6.24h2.76c.29,0,.55.06.8.18s.45.28.63.47.31.42.41.67.15.5.15.75c0,.4-.1.77-.3,1.1s-.48.57-.82.72l1.42,2.35h-1.36l-1.27-2.09h-1.2v2.09h-1.21ZM533.98,382.74h1.52c.11,0,.22-.03.31-.08s.18-.12.25-.21.13-.2.17-.32.06-.25.06-.4-.02-.28-.07-.4-.11-.23-.19-.32-.17-.16-.27-.21-.21-.08-.31-.08h-1.47v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M538.61,385.89v-6.24h1.21v6.24h-1.21Z"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 62.71,
    y1: 25.42,
    x2: 428.32,
    y2: 25.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.68,163.07h46.76c1.41,0,2.56,1.15,2.56,2.56v39.78c0,1.41-1.15,2.56-2.56,2.56h-46.76v-44.91h0Z",
    transform: "translate(298.87 72.18) rotate(90)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2388"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_88",
    className: "cls-8",
    cx: 466.84,
    cy: 44.26,
    rx: 20.44,
    ry: 19.72,
    style: {
      fill: "#d33a3a",
      zIndex: 99999999,
      z: 999999999
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_87",
    className: "cls-10",
    cx: 466.84,
    cy: 44.26,
    rx: 9.68,
    ry: 10.04,
    style: {
      fill: "#d33a3a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Voi_siete_qui",
    className: "cls-9",
    style: {
      color: "#d33a3a"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M437.66,79.19l2.75,7.7,2.73-7.7h2.08s-3.97,10.18-3.97,10.18h-1.66s-4-10.18-4-10.18h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M450.28,89.44c-.75,0-1.42-.15-2.03-.44-.61-.29-1.13-.68-1.56-1.16-.44-.48-.77-1.04-1.01-1.66-.24-.62-.36-1.26-.36-1.91s.13-1.33.38-1.95c.25-.62.6-1.17,1.05-1.65.44-.48.97-.86,1.58-1.14.61-.28,1.28-.42,1.99-.42s1.41.15,2.02.45c.61.3,1.13.7,1.56,1.18.43.49.76,1.04,1,1.66.24.62.36,1.25.36,1.89,0,.68-.12,1.33-.37,1.94-.25.62-.59,1.16-1.03,1.64-.44.47-.97.85-1.58,1.13-.61.28-1.28.42-1.99.42ZM447.33,84.28c0,.44.07.87.2,1.28.13.41.33.77.58,1.09.25.32.56.57.93.76s.79.29,1.26.29.9-.1,1.27-.29c.37-.2.68-.46.93-.78s.44-.69.57-1.1c.13-.41.19-.82.19-1.24s-.07-.87-.21-1.28-.33-.77-.59-1.09-.56-.57-.93-.75-.78-.28-1.24-.28-.9.1-1.28.29c-.37.2-.68.46-.93.78-.25.32-.44.68-.57,1.09-.13.41-.19.82-.19,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M456.78,89.37v-10.18h1.98v10.18h-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M470.39,81.86c-.07-.07-.19-.16-.37-.27-.18-.12-.39-.23-.65-.34-.25-.11-.53-.2-.83-.28-.3-.08-.6-.11-.9-.11-.55,0-.95.1-1.22.3-.27.2-.4.48-.4.85,0,.21.05.38.15.52.1.14.25.26.44.37s.43.2.72.29c.29.09.63.18,1.01.27.5.13.95.28,1.36.43.41.15.75.34,1.03.57.28.23.5.5.65.82.15.32.23.71.23,1.18,0,.54-.1,1.01-.31,1.4-.21.39-.48.7-.83.94-.35.24-.75.41-1.21.52-.45.11-.93.17-1.43.17-.77,0-1.52-.12-2.27-.34-.75-.23-1.42-.55-2.01-.98l.88-1.71c.09.09.24.2.47.34.22.14.49.28.8.42.31.14.65.26,1.02.35.37.1.76.14,1.15.14,1.09,0,1.64-.35,1.64-1.05,0-.22-.06-.41-.19-.56-.12-.15-.3-.29-.53-.4-.23-.12-.51-.22-.83-.32-.33-.1-.69-.2-1.09-.32-.49-.13-.91-.28-1.27-.44-.36-.16-.66-.34-.9-.56-.24-.21-.42-.46-.54-.75s-.18-.62-.18-1.01c0-.52.1-.98.29-1.38.19-.4.46-.74.8-1s.73-.47,1.18-.61c.45-.14.93-.21,1.45-.21.72,0,1.38.11,1.98.34s1.13.49,1.58.8l-.88,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M473.12,89.37v-10.18h1.98v10.18h-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M484.29,87.64v1.74h-7.07v-10.18h6.94v1.74h-4.96s0,2.45,0,2.45h4.29v1.61h-4.29s0,2.65,0,2.65h5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M493.46,80.92h-3.26s0,8.45,0,8.45h-1.97v-8.45s-3.26,0-3.26,0v-1.74h8.48v1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M501.79,87.64v1.74h-7.07v-10.18h6.94v1.74h-4.96s0,2.45,0,2.45h4.29v1.61h-4.29s0,2.65,0,2.65h5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M513.71,88.71c-.37.23-.77.41-1.2.54-.43.13-.89.19-1.38.19-.75,0-1.42-.15-2.03-.44-.61-.3-1.13-.68-1.56-1.16-.44-.48-.77-1.03-1.01-1.65-.24-.62-.36-1.26-.36-1.91s.13-1.33.38-1.95c.25-.62.6-1.17,1.05-1.65.44-.48.97-.86,1.58-1.14.61-.28,1.28-.42,1.99-.42s1.41.15,2.02.45c.61.3,1.13.7,1.56,1.18.43.49.76,1.04,1,1.66.24.62.36,1.25.36,1.89s-.12,1.29-.35,1.89c-.23.6-.56,1.14-.98,1.61l1.39,1.56h-1.86s-.59-.66-.59-.66ZM511.14,87.69c.26,0,.5-.03.72-.09s.43-.15.62-.25l-1.55-1.75h1.87s.7.79.7.79c.19-.31.34-.64.44-1,.1-.36.16-.73.16-1.11,0-.44-.07-.87-.21-1.28s-.33-.77-.59-1.09-.56-.57-.93-.76c-.37-.19-.78-.29-1.24-.29s-.9.1-1.28.29c-.37.2-.68.46-.93.78-.25.33-.44.69-.57,1.1-.13.41-.19.82-.19,1.24,0,.44.07.87.2,1.28.13.41.33.77.58,1.09.25.32.56.57.93.76s.79.29,1.26.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M521.92,87.69c.47,0,.86-.09,1.18-.29s.58-.44.77-.75.33-.66.42-1.05c.08-.4.12-.81.12-1.23v-5.19h1.97v5.19c0,.7-.08,1.35-.25,1.97-.17.61-.43,1.15-.79,1.61-.36.46-.82.82-1.38,1.09-.56.27-1.24.4-2.02.4s-1.5-.14-2.07-.42c-.57-.28-1.03-.66-1.38-1.12-.35-.46-.61-1-.77-1.61s-.24-1.25-.24-1.91v-5.19h1.98v5.19c0,.43.04.84.12,1.24.08.4.22.75.42,1.05.2.31.45.55.77.74.32.19.7.28,1.16.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M528.37,89.37v-10.18h1.98v10.18h-1.98Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_A._Pininfarina",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222",
    className: "cls-12",
    d: "M320.8,75.92v-31.83h145.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 269.29,
    y: 12.85,
    width: 110.01,
    height: 208.06,
    transform: "translate(441.17 -207.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2142-2",
    "data-name": "Raggruppa_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1155-2",
    "data-name": "Rettangolo_1155",
    className: "cls-13",
    x: 289.14,
    y: 101.06,
    width: 70.31,
    height: 31.64,
    rx: 8.79,
    ry: 8.79
  }), /*#__PURE__*/React.createElement("g", {
    id: "SALA_PININFARINA-2",
    "data-name": "SALA_PININFARINA"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M317.55,110.52s-.12-.1-.22-.17-.24-.14-.4-.21-.32-.12-.51-.17-.37-.07-.55-.07c-.33,0-.58.06-.75.18s-.25.3-.25.52c0,.13.03.24.09.32s.15.16.27.22.27.12.44.18.39.11.62.17c.3.08.58.17.83.26s.46.21.63.35.31.31.4.51.14.44.14.72c0,.33-.06.62-.19.86s-.3.43-.51.58-.46.25-.74.32c-.28.07-.57.1-.87.1-.47,0-.93-.07-1.39-.21s-.87-.34-1.23-.6l.54-1.05c.05.05.15.12.29.21s.3.17.49.25.4.16.62.21.46.09.7.09c.67,0,1-.21,1-.64,0-.13-.04-.25-.11-.34s-.18-.18-.33-.25-.31-.13-.51-.19-.42-.12-.67-.19c-.3-.08-.56-.17-.78-.27s-.4-.21-.55-.34-.26-.28-.33-.46-.11-.38-.11-.62c0-.32.06-.6.18-.84s.28-.45.49-.62.45-.29.73-.37.57-.13.89-.13c.44,0,.84.07,1.21.21s.69.3.97.49l-.54.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M320.89,108.88h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM322.28,112.71l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.02,115.12v-6.24h1.21v5.18h3.18v1.06h-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.93,108.88h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM333.32,112.71l-.86-2.45-.9,2.45h1.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M297.37,124.79v-6.24h2.65c.29,0,.55.06.8.18s.45.28.63.47.31.42.41.67.15.5.15.75-.05.52-.14.77-.23.47-.4.66-.38.35-.62.47-.5.18-.79.18h-1.48v2.09h-1.21ZM298.58,121.64h1.41c.22,0,.41-.09.56-.27s.22-.43.22-.74c0-.16-.02-.3-.07-.43s-.11-.23-.18-.32-.17-.15-.27-.2-.21-.07-.31-.07h-1.35v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M302.84,124.79v-6.24h1.21v6.24h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M306.57,120.79v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M312.06,124.79v-6.24h1.21v6.24h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.79,120.79v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M321.28,124.79v-6.24h4.19v1.06h-2.98v1.61h2.48v.98h-2.48v2.58h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M327.41,118.55h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM328.81,122.38l-.86-2.45-.9,2.45h1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.55,124.79v-6.24h2.76c.29,0,.55.06.8.18s.45.28.63.47.31.42.41.67.15.5.15.75c0,.4-.1.77-.3,1.1s-.48.57-.82.72l1.42,2.35h-1.36l-1.27-2.09h-1.2v2.09h-1.21ZM332.76,121.64h1.52c.11,0,.22-.03.31-.08s.18-.12.25-.21.13-.2.17-.32.06-.25.06-.4-.02-.28-.07-.4-.11-.23-.19-.32-.17-.16-.27-.21-.21-.08-.31-.08h-1.47v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.39,124.79v-6.24h1.21v6.24h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.12,120.79v4h-1.21v-6.24h.94l3.25,4.1v-4.09h1.21v6.23h-.98l-3.21-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M348.38,118.55h1.07l2.37,6.24h-1.25l-.58-1.56h-2.18l-.57,1.56h-1.25l2.38-6.24ZM349.78,122.38l-.86-2.45-.9,2.45h1.76Z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_A",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-2",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M170.14,692.61l-93.17-.2v-179.12h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.78,645.77h142.55c1.41,0,2.56,1.15,2.56,2.56v87.02c0,1.41-1.15,2.56-2.56,2.56H105.22v-89.58c0-1.41,1.15-2.56,2.56-2.56Z",
    transform: "translate(870.9 512.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2126-2",
    "data-name": "Raggruppa_2126"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-2",
    "data-name": "Ellisse_90",
    className: "cls-13",
    cx: 179.06,
    cy: 691.84,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "A-2",
    "data-name": "A",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M178.32,687.12h1.5l3.32,8.74h-1.75l-.81-2.18h-3.05l-.8,2.18h-1.75l3.33-8.74ZM180.27,692.49l-1.21-3.43-1.25,3.43h2.46Z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_B",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-3",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M52,739.82l24.96-.2v-226.33h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.76,709.07h48.26c1.41,0,2.56,1.15,2.56,2.56v56.17c0,1.41-1.15,2.56-2.56,2.56H6.76v-61.3h0Z",
    transform: "translate(771.89 707.55) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2127-2",
    "data-name": "Raggruppa_2127"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-2-2",
    "data-name": "Ellisse_90-2",
    className: "cls-13",
    cx: 32.17,
    cy: 740.47,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "B-2",
    "data-name": "B",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M35.94,742.23c0,.37-.07.69-.22.97-.15.28-.35.51-.61.7s-.56.33-.9.43c-.34.1-.7.15-1.09.15h-4.22v-8.74h4.68c.3,0,.58.07.82.2.25.13.46.3.63.51.17.21.31.45.4.71.09.27.14.54.14.81,0,.43-.11.83-.32,1.2-.21.37-.53.65-.94.83.5.15.9.41,1.19.79.29.38.44.86.44,1.43ZM30.6,737.2v2.2h2.26c.29,0,.53-.1.73-.29.2-.2.3-.47.3-.81s-.09-.6-.28-.8c-.18-.2-.41-.29-.68-.29h-2.34ZM34.23,741.91c0-.16-.03-.31-.08-.45s-.12-.27-.21-.38c-.09-.11-.2-.19-.32-.25s-.26-.09-.41-.09h-2.61v2.3h2.52c.16,0,.3-.03.44-.09.14-.06.25-.14.35-.24.1-.1.18-.22.23-.36.06-.14.09-.29.09-.44Z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_C",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-4",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M52,692.68l24.96-.2v-179.19h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.86,
    y: 662.35,
    width: 42.63,
    height: 61.3,
    transform: "translate(725.17 660.82) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2128-2",
    "data-name": "Raggruppa_2128"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-3-2",
    "data-name": "Ellisse_90-3",
    className: "cls-13",
    cx: 32.17,
    cy: 693.01,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "C-2",
    "data-name": "C",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.33,692.59c0-.53.1-1.06.29-1.58.19-.52.47-.99.84-1.4s.82-.74,1.35-1c.53-.25,1.14-.38,1.82-.38.8,0,1.5.18,2.08.53.59.35,1.02.81,1.31,1.38l-1.3.9c-.11-.25-.25-.45-.42-.62s-.34-.3-.53-.4-.39-.17-.59-.22c-.21-.04-.41-.07-.6-.07-.43,0-.8.09-1.11.26-.32.17-.58.4-.79.67-.21.28-.37.59-.47.94s-.16.7-.16,1.04c0,.39.06.76.18,1.11.12.36.3.67.52.94.23.27.5.49.81.65.32.17.66.25,1.04.25.2,0,.4-.02.62-.07.21-.05.42-.13.61-.23.19-.11.37-.24.54-.41.16-.17.29-.37.39-.61l1.39.8c-.14.33-.34.62-.6.87s-.55.46-.87.63c-.32.17-.67.3-1.04.39s-.73.14-1.08.14c-.62,0-1.19-.13-1.71-.39-.52-.26-.96-.6-1.34-1.03-.37-.42-.66-.9-.87-1.44s-.31-1.08-.31-1.64Z"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_D",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-5",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M35.4,650.69l41.56-.2v-137.2h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.86,
    y: 619.71,
    width: 42.63,
    height: 61.3,
    transform: "translate(682.53 618.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2129-2",
    "data-name": "Raggruppa_2129"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-4-2",
    "data-name": "Ellisse_90-4",
    className: "cls-13",
    cx: 32.17,
    cy: 650.82,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "D-2",
    "data-name": "D",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.68,654.83v-8.74h3.17c.71,0,1.34.12,1.88.34.54.23.99.54,1.35.94.36.39.63.85.81,1.38s.27,1.09.27,1.69c0,.67-.1,1.27-.3,1.8-.2.54-.49,1-.87,1.38-.38.38-.83.68-1.36.89s-1.12.31-1.78.31h-3.17ZM34.45,650.45c0-.42-.06-.8-.17-1.16-.11-.35-.28-.66-.5-.91-.22-.25-.49-.45-.82-.59s-.69-.21-1.1-.21h-1.48v5.76h1.48c.42,0,.79-.07,1.11-.22.32-.15.59-.35.81-.61.22-.26.38-.56.5-.92.12-.35.17-.73.17-1.14Z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_E",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-6",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M52,608.98l24.96-.2v-95.48h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.86,
    y: 577.08,
    width: 42.63,
    height: 61.3,
    transform: "translate(639.9 575.55) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2131-2",
    "data-name": "Raggruppa_2131"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-6-2",
    "data-name": "Ellisse_90-6",
    className: "cls-13",
    cx: 32.17,
    cy: 608.63,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "E-2",
    "data-name": "E",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.45,611.16v1.49h-6.07v-8.74h5.96v1.49h-4.26v2.1h3.68v1.38h-3.68v2.28h4.37Z"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_F",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-7",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M52,566.86l24.96-.2v-53.36h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.86,
    y: 534.44,
    width: 42.63,
    height: 61.3,
    transform: "translate(597.27 532.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2130-2",
    "data-name": "Raggruppa_2130"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-5-2",
    "data-name": "Ellisse_90-5",
    className: "cls-13",
    cx: 32.17,
    cy: 566.45,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "F-2",
    "data-name": "F",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.55,570.46v-8.74h5.87v1.49h-4.17v2.25h3.47v1.38h-3.47v3.62h-1.7Z"
  })))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_G",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-8",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M65.28,438.47h36.97s0-161.73,0-161.73h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-16.96,392.4h126.33c1.41,0,2.56,1.15,2.56,2.56v89.58H-16.96v-92.14h0Z",
    transform: "translate(485.96 390.98) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2132-2",
    "data-name": "Raggruppa_2132"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-7-2",
    "data-name": "Ellisse_90-7",
    className: "cls-13",
    cx: 47.22,
    cy: 438.47,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "G-2",
    "data-name": "G",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.74,441.5c-.7.7-1.51,1.05-2.44,1.05-.57,0-1.11-.12-1.62-.34s-.94-.54-1.32-.95c-.37-.4-.67-.88-.89-1.42-.22-.55-.33-1.13-.33-1.77,0-.6.11-1.16.33-1.69s.52-.99.9-1.39c.38-.4.83-.71,1.35-.95.52-.23,1.08-.35,1.69-.35.82,0,1.52.17,2.11.52.59.34,1.03.81,1.32,1.39l-1.27.94c-.22-.43-.53-.77-.93-1s-.83-.34-1.3-.34c-.37,0-.71.08-1.02.23-.31.16-.57.37-.79.64-.22.27-.39.58-.5.93-.12.35-.18.73-.18,1.12s.07.79.2,1.15c.13.36.31.67.54.93.23.26.5.47.82.62.32.15.66.23,1.03.23.84,0,1.61-.4,2.29-1.19v-.62h-1.76v-1.24h3.16v4.49h-1.4v-.98Z"
  })))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_H",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-9",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M79.88,331.22h22.37v-54.48h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.43,285.15h82.67v92.14H4.87v-89.58c0-1.41,1.15-2.56,2.56-2.56Z",
    transform: "translate(378.71 283.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2133-2",
    "data-name": "Raggruppa_2133"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-8-2",
    "data-name": "Ellisse_90-8",
    className: "cls-13",
    cx: 47.22,
    cy: 331.22,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "H-2",
    "data-name": "H",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.89,326.5v8.74h-1.69v-3.73h-3.96v3.73h-1.7v-8.74h1.7v3.53h3.96v-3.53h1.69Z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_I",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-10",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M49.74,267.29h26.64s0-223.2,0-223.2h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.86,
    y: 236.64,
    width: 42.63,
    height: 61.3,
    transform: "translate(299.46 235.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2134-2",
    "data-name": "Raggruppa_2134"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-9-2",
    "data-name": "Ellisse_90-9",
    className: "cls-13",
    cx: 32.17,
    cy: 267.29,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "I-2",
    "data-name": "I",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31.32,271.31v-8.74h1.7v8.74h-1.7Z"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_K",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-11",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M43.5,523.35h33.47s0-10.05,0-10.05h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.74,
    y: 492.7,
    width: 40.86,
    height: 61.3,
    transform: "translate(555.52 491.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2135-2",
    "data-name": "Raggruppa_2135"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-10-2",
    "data-name": "Ellisse_90-10",
    className: "cls-13",
    cx: 32.17,
    cy: 524.26,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "K-2",
    "data-name": "K",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.96,528.27v-8.72h1.7v4.15l3.67-4.16h1.87l-3.35,3.88,3.56,4.86h-1.91l-2.72-3.78-1.12,1.17v2.61h-1.7Z"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_L",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-12",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M36.89,226.31h39.49V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.86,
    y: 194.01,
    width: 42.63,
    height: 61.3,
    transform: "translate(256.83 192.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137-2",
    "data-name": "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12-2",
    "data-name": "Ellisse_90-12",
    className: "cls-13",
    cx: 32.17,
    cy: 226.31,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L-2",
    "data-name": "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.49,230.33v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_M",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-13",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M53.41,181.75h22.97V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.86,
    y: 151.37,
    width: 42.63,
    height: 61.3,
    transform: "translate(214.19 149.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138-2",
    "data-name": "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13-2",
    "data-name": "Ellisse_90-13",
    className: "cls-13",
    cx: 32.17,
    cy: 182.02,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M-2",
    "data-name": "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.88,186.04v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_N",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-14",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M41.84,140.28h34.54V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.74,
    y: 109.63,
    width: 40.86,
    height: 61.3,
    transform: "translate(172.45 108.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2139-2",
    "data-name": "Raggruppa_2139"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-14-2",
    "data-name": "Ellisse_90-14",
    className: "cls-13",
    cx: 32.17,
    cy: 140.28,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "N-2",
    "data-name": "N",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.09,138.69v5.6h-1.7v-8.74h1.32l4.55,5.73v-5.72h1.7v8.72h-1.38l-4.49-5.6Z"
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_P",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-15",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M47.27,71.63h29.11v-27.55h389.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-15.04,41.98h94.43v61.3H-12.48c-1.41,0-2.56-1.15-2.56-2.56v-58.73h0Z",
    transform: "translate(104.8 40.46) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2140-2",
    "data-name": "Raggruppa_2140"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-15-2",
    "data-name": "Ellisse_90-15",
    className: "cls-13",
    cx: 32.17,
    cy: 71.63,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "P-2",
    "data-name": "P",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.25,75.65v-8.74h3.7c.4,0,.77.08,1.11.25.34.17.63.39.88.67s.44.59.58.93c.14.35.21.7.21,1.05s-.07.73-.2,1.08c-.13.35-.32.66-.55.93-.24.27-.53.49-.86.65-.34.16-.71.25-1.11.25h-2.07v2.93h-1.7ZM30.95,71.23h1.97c.31,0,.57-.13.78-.38.21-.25.31-.6.31-1.03,0-.22-.03-.42-.1-.6-.07-.18-.15-.33-.26-.45s-.23-.22-.38-.28c-.14-.06-.29-.09-.44-.09h-1.9v2.83Z"
  })))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_Q",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-16",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M179.54,80.62v-36.54h286.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.39,74.59h110.01v84.58h-107.44c-1.41,0-2.56-1.15-2.56-2.56v-82.02h0Z",
    transform: "translate(295.28 -61.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2141-2",
    "data-name": "Raggruppa_2141"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-16-2",
    "data-name": "Ellisse_90-16",
    className: "cls-13",
    cx: 178.39,
    cy: 116.88,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Q-2",
    "data-name": "Q",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M180.6,120.33c-.32.2-.66.35-1.03.46s-.76.17-1.18.17c-.64,0-1.22-.13-1.74-.38-.52-.25-.97-.59-1.34-1-.37-.41-.66-.88-.87-1.42s-.31-1.08-.31-1.64.11-1.14.33-1.67.52-1,.9-1.42c.38-.41.83-.74,1.36-.98s1.1-.36,1.71-.36,1.21.13,1.73.39.97.6,1.34,1.02c.37.42.66.89.86,1.43.2.53.31,1.08.31,1.62s-.1,1.11-.3,1.62c-.2.52-.48.98-.84,1.38l1.19,1.34h-1.6l-.5-.57ZM178.4,119.46c.22,0,.43-.03.62-.08s.37-.12.54-.22l-1.33-1.5h1.6l.6.68c.16-.26.29-.55.38-.86.09-.31.14-.63.14-.95,0-.38-.06-.74-.18-1.09-.12-.35-.29-.67-.5-.94s-.48-.49-.8-.65-.67-.25-1.06-.25-.77.08-1.09.25c-.32.17-.59.39-.8.67-.21.28-.38.59-.49.94-.11.35-.17.7-.17,1.06s.06.74.17,1.09c.11.35.28.67.5.94.22.27.48.49.8.65.32.16.67.25,1.08.25Z"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_B_C",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-17",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M52,720.12l24.96-.2v-206.63h25.28v-236.56h-25.86V44.08h389.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -14.83,
    y: 688.03,
    width: 94,
    height: 61.3,
    transform: "translate(750.85 686.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2127-3",
    "data-name": "Raggruppa_2127"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-2-3",
    "data-name": "Ellisse_90-2",
    className: "cls-13",
    cx: 32.17,
    cy: 737.37,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "B-3",
    "data-name": "B",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M35.94,739.14c0,.37-.07.69-.22.97-.15.28-.35.51-.61.7s-.56.33-.9.43c-.34.1-.7.15-1.09.15h-4.22v-8.74h4.68c.3,0,.58.07.82.2.25.13.46.3.63.51.17.21.31.45.4.71.09.27.14.54.14.81,0,.43-.11.83-.32,1.2-.21.37-.53.65-.94.83.5.15.9.41,1.19.79.29.38.44.86.44,1.43ZM30.6,734.1v2.2h2.26c.29,0,.53-.1.73-.29.2-.2.3-.47.3-.81s-.09-.6-.28-.8c-.18-.2-.41-.29-.68-.29h-2.34ZM34.23,738.82c0-.16-.03-.31-.08-.45s-.12-.27-.21-.38c-.09-.11-.2-.19-.32-.25s-.26-.09-.41-.09h-2.61v2.3h2.52c.16,0,.3-.03.44-.09.14-.06.25-.14.35-.24.1-.1.18-.22.23-.36.06-.14.09-.29.09-.44Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2128-3",
    "data-name": "Raggruppa_2128"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-3-3",
    "data-name": "Ellisse_90-3",
    className: "cls-13",
    cx: 32.17,
    cy: 702.67,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "C-3",
    "data-name": "C",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.33,702.26c0-.53.1-1.06.29-1.58.19-.52.47-.99.84-1.4s.82-.74,1.35-1c.53-.25,1.14-.38,1.82-.38.8,0,1.5.18,2.08.53.59.35,1.02.81,1.31,1.38l-1.3.9c-.11-.25-.25-.45-.42-.62s-.34-.3-.53-.4-.39-.17-.59-.22c-.21-.04-.41-.07-.6-.07-.43,0-.8.09-1.11.26-.32.17-.58.4-.79.67-.21.28-.37.59-.47.94s-.16.7-.16,1.04c0,.39.06.76.18,1.11.12.36.3.67.52.94.23.27.5.49.81.65.32.17.66.25,1.04.25.2,0,.4-.02.62-.07.21-.05.42-.13.61-.23.19-.11.37-.24.54-.41.16-.17.29-.37.39-.61l1.39.8c-.14.33-.34.62-.6.87s-.55.46-.87.63c-.32.17-.67.3-1.04.39s-.73.14-1.08.14c-.62,0-1.19-.13-1.71-.39-.52-.26-.96-.6-1.34-1.03-.37-.42-.66-.9-.87-1.44s-.31-1.08-.31-1.64Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M33.29,722.87h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_E_F",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-18",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v232.66h25.86v236.56h-25.28v73.25h-26.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -10.32,
    y: 555.9,
    width: 84.99,
    height: 61.3,
    transform: "translate(618.72 554.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,589.4h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2130-3",
    "data-name": "Raggruppa_2130"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-5-3",
    "data-name": "Ellisse_90-5",
    className: "cls-13",
    cx: 32.17,
    cy: 568.03,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "F-3",
    "data-name": "F",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.55,572.05v-8.74h5.87v1.49h-4.17v2.25h3.47v1.38h-3.47v3.62h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2131-3",
    "data-name": "Raggruppa_2131"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-6-3",
    "data-name": "Ellisse_90-6",
    className: "cls-13",
    cx: 32.17,
    cy: 605.06,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "E-3",
    "data-name": "E",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M35.45,607.59v1.49h-6.07v-8.74h5.96v1.49h-4.26v2.1h3.68v1.38h-3.68v2.28h4.37Z"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_G_H",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-19",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v232.66h25.86v119.19h-32.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -59.87,
    y: 349.85,
    width: 214.19,
    height: 91.95,
    transform: "translate(443.05 348.6) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M48,398.78h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2132-3",
    "data-name": "Raggruppa_2132"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-7-3",
    "data-name": "Ellisse_90-7",
    className: "cls-13",
    cx: 47.22,
    cy: 414.69,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "G-3",
    "data-name": "G"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M49.74,417.72c-.7.7-1.51,1.05-2.44,1.05-.57,0-1.11-.12-1.62-.34s-.94-.54-1.32-.95c-.37-.4-.67-.88-.89-1.42-.22-.55-.33-1.13-.33-1.77,0-.6.11-1.16.33-1.69s.52-.99.9-1.39c.38-.4.83-.71,1.35-.95.52-.23,1.08-.35,1.69-.35.82,0,1.52.17,2.11.52.59.34,1.03.81,1.32,1.39l-1.27.94c-.22-.43-.53-.77-.93-1s-.83-.34-1.3-.34c-.37,0-.71.08-1.02.23-.31.16-.57.37-.79.64-.22.27-.39.58-.5.93-.12.35-.18.73-.18,1.12s.07.79.2,1.15c.13.36.31.67.54.93.23.26.5.47.82.62.32.15.66.23,1.03.23.84,0,1.61-.4,2.29-1.19v-.62h-1.76v-1.24h3.16v4.49h-1.4v-.98Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2133-3",
    "data-name": "Raggruppa_2133"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-8-3",
    "data-name": "Ellisse_90-8",
    className: "cls-13",
    cx: 47.22,
    cy: 376.96,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "H-3",
    "data-name": "H"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M50.89,372.24v8.74h-1.69v-3.73h-3.96v3.73h-1.7v-8.74h1.7v3.53h3.96v-3.53h1.69Z"
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_I_L",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-20",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v201.89h-24.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -10.32,
    y: 215.32,
    width: 84.99,
    height: 61.3,
    transform: "translate(278.15 213.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,248.82h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2134-3",
    "data-name": "Raggruppa_2134"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-9-3",
    "data-name": "Ellisse_90-9",
    className: "cls-13",
    cx: 32.17,
    cy: 264.49,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "I-3",
    "data-name": "I",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M31.32,268.5v-8.74h1.7v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137-3",
    "data-name": "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12-3",
    "data-name": "Ellisse_90-12",
    className: "cls-13",
    cx: 32.17,
    cy: 227.46,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L-3",
    "data-name": "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.49,231.47v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_I_L_M",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-21",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v180.57h-24.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -31.71,
    y: 193.94,
    width: 127.76,
    height: 61.3,
    transform: "translate(256.76 192.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,245.4h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,209.47h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2134-4",
    "data-name": "Raggruppa_2134"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-9-4",
    "data-name": "Ellisse_90-9",
    className: "cls-13",
    cx: 32.17,
    cy: 260.52,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "I-4",
    "data-name": "I",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M31.32,264.53v-8.74h1.7v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137-4",
    "data-name": "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12-4",
    "data-name": "Ellisse_90-12",
    className: "cls-13",
    cx: 32.17,
    cy: 224.59,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L-4",
    "data-name": "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.49,228.6v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138-3",
    "data-name": "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13-3",
    "data-name": "Ellisse_90-13",
    className: "cls-13",
    cx: 32.17,
    cy: 188.66,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M-3",
    "data-name": "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.88,192.67v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  }))))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_I_L_M_N",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-22",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v160.24h-24.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -51.97,
    y: 173.68,
    width: 168.28,
    height: 61.3,
    transform: "translate(236.5 172.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,242.77h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,207.17h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,171.58h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2134-5",
    "data-name": "Raggruppa_2134"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-9-5",
    "data-name": "Ellisse_90-9",
    className: "cls-13",
    cx: 32.17,
    cy: 257.72,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "I-5",
    "data-name": "I",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M31.32,261.74v-8.74h1.7v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137-5",
    "data-name": "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12-5",
    "data-name": "Ellisse_90-12",
    className: "cls-13",
    cx: 32.17,
    cy: 222.12,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L-5",
    "data-name": "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.49,226.14v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138-4",
    "data-name": "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13-4",
    "data-name": "Ellisse_90-13",
    className: "cls-13",
    cx: 32.17,
    cy: 186.53,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M-4",
    "data-name": "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.88,190.54v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2139-3",
    "data-name": "Raggruppa_2139"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-14-3",
    "data-name": "Ellisse_90-14",
    className: "cls-13",
    cx: 32.17,
    cy: 150.93,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "N-3",
    "data-name": "N",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M30.09,149.35v5.6h-1.7v-8.74h1.32l4.55,5.73v-5.72h1.7v8.72h-1.38l-4.49-5.6Z"
  }))))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_L_M",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-23",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v160.24h-24.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -10.51,
    y: 172.64,
    width: 85.37,
    height: 61.3,
    transform: "translate(235.46 171.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,207.17h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137-6",
    "data-name": "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12-6",
    "data-name": "Ellisse_90-12",
    className: "cls-13",
    cx: 32.17,
    cy: 222.12,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L-6",
    "data-name": "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.49,226.14v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138-5",
    "data-name": "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13-5",
    "data-name": "Ellisse_90-13",
    className: "cls-13",
    cx: 32.17,
    cy: 186.53,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M-5",
    "data-name": "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.88,190.54v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  }))))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_L_M_N",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-24",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v140.03h-24.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -31.76,
    y: 153.47,
    width: 127.87,
    height: 61.3,
    transform: "translate(216.29 151.95) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,204.76h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,169.17h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2137-7",
    "data-name": "Raggruppa_2137"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-12-7",
    "data-name": "Ellisse_90-12",
    className: "cls-13",
    cx: 32.17,
    cy: 219.71,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "L-7",
    "data-name": "L",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.49,223.73v-8.74h1.7v7.25h4.45v1.49h-6.15Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138-6",
    "data-name": "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13-6",
    "data-name": "Ellisse_90-13",
    className: "cls-13",
    cx: 32.17,
    cy: 184.12,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M-6",
    "data-name": "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.88,188.13v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2139-4",
    "data-name": "Raggruppa_2139"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-14-4",
    "data-name": "Ellisse_90-14",
    className: "cls-13",
    cx: 32.17,
    cy: 148.52,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "N-4",
    "data-name": "N",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M30.09,146.94v5.6h-1.7v-8.74h1.32l4.55,5.73v-5.72h1.7v8.72h-1.38l-4.49-5.6Z"
  }))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Sala_M_N",
    className: "percorso_sala"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3222-25",
    "data-name": "Tracciato_3222",
    className: "cls-12",
    d: "M465.9,44.08H76.38v117.68h-24.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -9.41,
    y: 131.11,
    width: 83.15,
    height: 61.3,
    transform: "translate(193.93 129.59) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.95,164.61h-1.55v-1.96h-2.14v-1.75h2.14v-1.98h1.55v1.98h2.14v1.75h-2.14v1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2138-7",
    "data-name": "Raggruppa_2138"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-13-7",
    "data-name": "Ellisse_90-13",
    className: "cls-13",
    cx: 32.17,
    cy: 179.56,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "M-7",
    "data-name": "M",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.88,183.58v-5.78l-2.25,4.31h-.92l-2.25-4.31v5.78h-1.7v-8.74h1.82l2.58,4.97,2.61-4.97h1.81v8.74h-1.7Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2139-5",
    "data-name": "Raggruppa_2139"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90-14-5",
    "data-name": "Ellisse_90-14",
    className: "cls-13",
    cx: 32.17,
    cy: 143.96,
    r: 9.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "N-5",
    "data-name": "N",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M30.09,142.38v5.6h-1.7v-8.74h1.32l4.55,5.73v-5.72h1.7v8.72h-1.38l-4.49-5.6Z"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMappaewayfinding, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mappa e wayfinding.e65c9c3b.svg";
export { ForwardRef as ReactComponent };